import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./SurveyWidgetPanel.module.scss";

const SurveyProgressIndicator = ({
  total = 0,
  current = 0,
  labelTotal,
  labelCurrent,
  showProgressBar = false,
  isContactStep = false,
}) => {
  const { t } = useTranslation();

  if (total <= 0) return null;

  if (!showProgressBar) {
    const label =
      total === 1
        ? t("surveyManagement.widget.question_count_one")
        : t("surveyManagement.widget.question_count", { count: total });
    return (
      <div className={styles.progressWrap}>
        <span className={styles.progressLabel}>{label}</span>
      </div>
    );
  }

  const pct = Math.min(100, Math.round((current / total) * 100) || 0);
  const textTotal = labelTotal ?? total;
  const textCurrent = labelCurrent ?? current;
  const stepLabel = isContactStep
    ? t("surveyManagement.widget.step_contact", {
        current: textCurrent,
        total: textTotal,
      })
    : t("surveyManagement.widget.step_question", {
        current: textCurrent,
        total: textTotal,
      });

  return (
    <div className={styles.progressWrap}>
      <div className={styles.progressMeta}>
        <span>{stepLabel}</span>
        <span>{pct}%</span>
      </div>
      <div
        className={styles.progressBar}
        role="progressbar"
        aria-valuenow={current}
        aria-valuemin={0}
        aria-valuemax={total}
        aria-label={stepLabel}
      >
        <div className={styles.progressFill} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default SurveyProgressIndicator;
